export interface RuntimeConfig {
  apiUrl: string;
  keycloakUrl: string;
  keycloakRealm: string;
  keycloakClientId: string;
  environment?: string;
  werkUrl?: string;
}

const REQUIRED_KEYS = ['apiUrl', 'keycloakUrl', 'keycloakRealm', 'keycloakClientId'] as const;

let config: RuntimeConfig | undefined;

function assertValid(candidate: unknown): asserts candidate is RuntimeConfig {
  if (typeof candidate !== 'object' || candidate === null) {
    throw new Error('runtimeConfiguration.json did not contain a JSON object.');
  }

  const record = candidate as Record<string, unknown>;

  for (const key of REQUIRED_KEYS) {
    if (typeof record[key] !== 'string' || record[key].length === 0) {
      throw new Error(`runtimeConfiguration.json is missing the required string key "${key}".`);
    }
  }
}

export async function loadRuntimeConfig(): Promise<RuntimeConfig> {
  const response = await fetch('/runtimeConfiguration.json', { cache: 'no-store' });

  if (!response.ok) {
    throw new Error(`runtimeConfiguration.json returned ${response.status}.`);
  }

  let parsed: unknown;
  try {
    parsed = await response.json();
  } catch {
    throw new Error('runtimeConfiguration.json was not valid JSON.');
  }

  assertValid(parsed);
  config = parsed;

  return config;
}

export function getRuntimeConfig(): RuntimeConfig {
  if (!config) {
    throw new Error('getRuntimeConfig() was called before loadRuntimeConfig() resolved.');
  }

  return config;
}

export function resetRuntimeConfigForTests(next?: RuntimeConfig): void {
  config = next;
}
